/**
 * useAppJobDetails Hook
 *
 * Custom React Query hook for fetching a single appJob's details.
 */

import { useQuery } from '@tanstack/react-query';
import { appJobService } from '../../../api/app-job.service';

/**
 * Hook for fetching appJob details by ID
 * @param tenantId - Tenant ID
 * @param appJobId - AppJob ID
 * @param enabled - Whether the query should run
 */
export const useAppJobDetails = (
  tenantId: string,
  appJobId: string,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ['appJob', tenantId, appJobId],
    queryFn: async () => {
      const result = await appJobService.getAppJob(tenantId, appJobId);
      return result;
    },
    enabled: !!tenantId && !!appJobId && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
